module.exports = __webpack_public_path__ + "static/media/fuel_level.d56d035f.svg";